import { z } from "zod";
import { searchParam } from "@amber/ui";

const RECORD_TABS = ["speakers", "source", "processing", "history"] as const;
export type RecordTab = (typeof RECORD_TABS)[number];

export const evidenceSearchSchema = z.object({
  t: searchParam(z.coerce.number().nonnegative()),
  p: searchParam(z.coerce.number().int().positive()),
  tab: searchParam(z.enum(RECORD_TABS)),
  lang: searchParam(z.literal("en")),
  from: searchParam(z.enum(["backlog", "tasks", "search"])),
  communication: searchParam(z.coerce.number().int().positive()),
});
export type EvidenceSearch = z.infer<typeof evidenceSearchSchema>;
